import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { HeaderMenuComponent } from '@mds/ngx-auth';
import {
  HeaderComponent,
  LoadingIndicatorComponent,
  ShellComponent,
} from '@mds/ngx-layout';

@Component({
  imports: [
    RouterModule,
    ShellComponent,
    HeaderComponent,
    HeaderMenuComponent,
    LoadingIndicatorComponent,
    MatIcon,
    MatButtonModule,
  ],
  selector: 'rpl-root',
  templateUrl: './app.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'rpl';

  constructor() {
    inject(MatIconRegistry).setDefaultFontSetClass('material-symbols-outlined');
  }
}
